export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7139.b1816a90.jpg";